import qs from 'qs';
import { setAuthToken, getAuthToken } from './Authentication';

const ReLogin = require('./ReLogin');
const { getCognitoTokens, reFreshCognitoTokens } = require('../../api');

let intervalTask = null;

const RefreshToken = refresh_token => {
  if (intervalTask) {
    clearInterval(intervalTask);
  }
  intervalTask = setInterval(
    () =>
      reFreshCognitoTokens(refresh_token).then(tokens => {
        if (tokens.id_token) {
          setAuthToken(tokens.id_token, 'id_token');
        }
        if (tokens.refresh_token) {
          setAuthToken(tokens.refresh_token, 'refresh_token');
        }
      }),
    10 * 60 * 1000
  );
};

const refreshToken = getAuthToken('refresh_token');

if (refreshToken) {
  RefreshToken(refreshToken);
}

const Login = async () => {
  const currentUrl = window.location.href;
  let query = null;
  if (currentUrl.indexOf('?') >= 0) {
    query = qs.parse(currentUrl.split('?')[1].replace('\\', ''));
  }
  if (query && query.code) {
    const code = query.code;
    getCognitoTokens(code).then(async tokens => {
      if (tokens) {
        if (tokens.id_token) {
          await setAuthToken(tokens.id_token, 'id_token');
        }
        if (tokens.refresh_token) {
          await setAuthToken(tokens.refresh_token, 'refresh_token');
        }
        window.location.href = window.location.origin;
      } else {
        ReLogin();
      }
    });
  } else {
    const idToken = await getAuthToken('id_token');
    if (!idToken) {
      ReLogin();
    } else {
      return { login: true };
    }
  }
  return { login: false };
};

export default Login;



// WEBPACK FOOTER //
// ./src/components/authentication/Login.js